export const ADD_MESSAGE = 'FLASH_MESSAGE/ADD';
export const REMOVE_MESSAGE = 'FLASH_MESSAGE/REMOVE';
export const REMOVE_ALL_MESSAGES = 'FLASH_MESSAGE/REMOVE_ALL';
export const DEFAULT_TIMEOUT = 4500;
